import { defineAction } from '~/prix'
import { z } from 'zod'
import creditRequestFetchAction from './creditRequestFetch.action.json' with { type: 'json' }
import { creditRequestObject } from '../creditRequestObject'

const creditRequestFetchDefinition = defineAction({
  ...creditRequestFetchAction,

  input: z.object({
    id: creditRequestObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: creditRequestObject,
})

export default creditRequestFetchDefinition

